export default __webpack_public_path__ + "images/PU.88abcbd.png";